export interface IBank {
    BankName: string;
    BankShortCode: string;
    Type: string;
    Founded?: string;
    Founder?: string;
    Headquarters?: string;
    Formerly?: string;
    Owner?: string;
    Website: string;
}

export const BANK_LIST: IBank[] = [
    {
        "BankName": "Bkash",
        "BankShortCode": "Bkash",
        "Type": "",
        "Founded": "",
        "Headquarters": "",
        "Website": ""
    },
    {
        "BankName": "Nagad",
        "BankShortCode": "Nagad",
        "Type": "",
        "Founded": "",
        "Headquarters": "",
        "Website": ""
    },
    {
        "BankName": "Rocket",
        "BankShortCode": "Rocket",
        "Type": "",
        "Founded": "",
        "Headquarters": "",
        "Website": ""
    },
    {
        "BankName": "Upay",
        "BankShortCode": "Upay",
        "Type": "",
        "Founded": "",
        "Headquarters": "",
        "Website": ""
    },
    {
        "BankName": "AB Bank Ltd.",
        "BankShortCode": "ABL",
        "Type": "Private Commercial Banks",
        "Founded": "April 2, 1982",
        "Headquarters": "Dhaka, Bangladesh",
        "Website": "abbl.com"
    },
    {
        "BankName": "Agrani Bank",
        "BankShortCode": "ABL",
        "Type": "State Owned Commercial Banks",
        "Founded": "26 March 1972",
        "Headquarters": "Dhaka, Bangladesh",
        "Website": "www.agranibank.org"
    },
    {
        "BankName": "Al-Arafah Islami Bank Ltd.",
        "BankShortCode": "AAIBL",
        "Type": "Private Commercial Banks",
        "Founded": "1995",
        "Headquarters": "Dhaka, Bangladesh",
        "Website": "al-arafahbank.com"
    },
    {
        "BankName": "Ansar VDP Unnayan Bank",
        "BankShortCode": "AVUB",
        "Type": "Non-scheduled banks",
        "Founded": "Dhaka, Bangladesh",
        "Headquarters": "Dhaka, Bangladesh",
        "Website": "ansarvdpbank.gov.bd"
    },
    {
        "BankName": "BASIC Bank",
        "BankShortCode": "BBL",
        "Type": "State Owned Commercial Banks",
        "Founded": "",
        "Headquarters": "Dhaka, Bangladesh",
        "Website": "http://www.basicbanklimited.com/"
    },
    {
        "BankName": "BRAC Bank Ltd.",
        "BankShortCode": "BBL",
        "Type": "Private Commercial Banks",
        "Founded": "4 July 2001",
        "Headquarters": "220/B Gulshan Tejgaon Link Road, Dhaka 1208 Dhaka, Bangladesh",
        "Website": "www.bracbank.com"
    },
    {
        "BankName": "Bangladesh Commerce Bank Ltd.",
        "BankShortCode": "BCBL",
        "Type": "Private Commercial Banks",
        "Founded": "Dhaka, Bangladesh",
        "Headquarters": "Dhaka, Bangladesh",
        "Website": ""
    },
    {
        "BankName": "Bangladesh Development Bank",
        "BankShortCode": "BDB",
        "Type": "State Owned Commercial Banks",
        "Founded": "16 November 2009",
        "Website": "www.bdbl.com.bd"
    },
    {
        "BankName": "Bangladesh Krishi Bank",
        "BankShortCode": "BKB",
        "Type": "Specialized Banks",
        "Founded": "Dhaka, Bangladesh",
        "Headquarters": "Dhaka, Bangladesh",
        "Website": "http://www.krishibank.org.bd/"
    },
    {
        "BankName": "Bank Al-Falah",
        "BankShortCode": "BAFL",
        "Formerly": "Habib Credit & Exchange Bank Limited",
        "Type": "Foreign Commercial Banks",
        "Founded": "June 21, 1997",
        "Headquarters": "Karachi, Pakistan",
        "Owner": "Abu Dhabi Group",
        "Website": "www.bankalfalah.com"
    },
    {
        "BankName": "Bank Asia Ltd.",
        "BankShortCode": "BAL",
        "Type": "Private Commercial Banks",
        "Founded": "27 November 1999",
        "Headquarters": "Dhaka, Bangladesh",
        "Website": "Bank Asia Limited"
    },
    {
        "BankName": "CITI Bank NA",
        "BankShortCode": "CITIBNA",
        "Type": "Foreign Commercial Banks",
        "Founded": "June 16, 1812",
        "Headquarters": "New York City, New York",
        "Website": "citi.com"
    },
    {
        "BankName": "Commercial Bank of Ceylon",
        "BankShortCode": "CBOC",
        "Type": "Foreign Commercial Banks",
        "Founded": "1920",
        "Headquarters": "Colombo, Sri Lanka",
        "Owner": "Citigroup (13.15%)Employees' Provident Fund (7.78%)Deutsche Bank (5.52%)",
        "Website": ""
    },
    {
        "BankName": "Community Bank Bangladesh Limited",
        "BankShortCode": "CBBL",
        "Type": "Private Commercial Banks",
        "Founded": "2019",
        "Headquarters": "Dhaka, Bangladesh",
        "Website": "www.communitybankbd.com"
    },
    {
        "BankName": "Dhaka Bank Ltd.",
        "BankShortCode": "DBL",
        "Type": "Private Commercial Banks",
        "Founded": "July 5, 1995",
        "Founder": "Mirza Abbas",
        "Headquarters": "Dhaka, Bangladesh",
        "Website": "dhakabankltd.com"
    },
    {
        "BankName": "Dutch Bangla Bank Ltd.",
        "BankShortCode": "DBBL",
        "Type": "Private Commercial Banks",
        "Founded": "1995",
        "Headquarters": "Motijheel, Dhaka, Bangladesh",
        "Website": "dutchbanglabank.com"
    },
    {
        "BankName": "EXIM Bank Ltd.",
        "BankShortCode": "EXIM",
        "Type": "Private Commercial Banks",
        "Founded": "3 August 1999",
        "Founder": "Late Mr. Shahjahan Kabir",
        "Headquarters": "Dhaka, Bangladesh",
        "Website": "www.eximbankbd.com"
    },
    {
        "BankName": "Eastern Bank Ltd.",
        "BankShortCode": "EBL",
        "Type": "Private Commercial Banks",
        "Founded": "August 8, 1992",
        "Headquarters": "Dhaka, Bangladesh",
        "Website": "ebl.com.bd"
    },
    {
        "BankName": "First Security Islami Bank Ltd.",
        "BankShortCode": "FSIBL",
        "Type": "Private Commercial Banks",
        "Founded": "25 October 1999",
        "Headquarters": "Dhaka, Bangladesh",
        "Website": "fsiblbd.com"
    },
    {
        "BankName": "Global Islamic Bank Ltd.",
        "BankShortCode": "GIBL",
        "Type": "Private Commercial Banks",
        "Website": "https://www.globalislamibankbd.com/"
    },
    {
        "BankName": "Grameen Bank",
        "BankShortCode": "GB",
        "Type": "Non-scheduled banks",
        "Founded": "October 1983 (1983-10)",
        "Founder": "Muhammad Yunus",
        "Headquarters": "Dhaka, Bangladesh",
        "Website": "grameen.com"
    },
    {
        "BankName": "HSBC",
        "BankShortCode": "HSBC",
        "Type": "Foreign Commercial Banks",
        "Founded": "3 March 1865",
        "Founder": "Sir Thomas Sutherland",
        "Headquarters": "HSBC Main Building, Central, Hong Kong",
        "Website": "www.hsbc.com.hk"
    },
    {
        "BankName": "Habib Bank Ltd.",
        "BankShortCode": "HBL",
        "Type": "Foreign Commercial Banks",
        "Founded": "25 August 1940",
        "Founder": "Mohammed Ali Habib[2]  Dawood Habib[2]",
        "Headquarters": "Habib Bank Plaza, Karachi, Pakistan",
        "Website": "www.hbl.com"
    },
    {
        "BankName": "ICB Islamic Bank",
        "BankShortCode": "IIBL",
        "Type": "Private Commercial Banks",
        "Founded": "1987",
        "Headquarters": "Dhaka, Bangladesh",
        "Website": "https://www.icbislamic-bd.com/"
    },
    {
        "BankName": "IFIC Bank Ltd.",
        "BankShortCode": "IBL",
        "Type": "Private Commercial Banks",
        "Founded": "1976",
        "Headquarters": "Dhaka, Bangladesh",
        "Website": "www.ificbankbd.com"
    },
    {
        "BankName": "Islami Bank Bangladesh Ltd.",
        "BankShortCode": "IBBL",
        "Type": "Private Commercial Banks",
        "Founded": "13 March 1983",
        "Headquarters": "Islami Bank Tower 40, Dilkusha C/A, Dhaka - 1000, Bangladesh",
        "Website": "islamibankbd.com"
    },
    {
        "BankName": "Jamuna Bank Ltd.",
        "BankShortCode": "JBL",
        "Type": "Private Commercial Banks",
        "Founded": "2001",
        "Headquarters": "Dhaka, Bangladesh",
        "Website": "www.jamunabankbd.com"
    },
    {
        "BankName": "Janata Bank",
        "BankShortCode": "JBL",
        "Type": "State Owned Commercial Banks",
        "Founded": "1971",
        "Headquarters": "Dhaka, Bangladesh",
        "Website": "http://www.jb.com.bd/"
    },
    {
        "BankName": "Jubilee Bank",
        "BankShortCode": "JB",
        "Type": "Non-scheduled banks",
        "Founded": "Kushtia, Bangladesh",
        "Headquarters": "Kushtia, Bangladesh",
        "Website": "jubileebank.com"
    },
    {
        "BankName": "Karmashangosthan Bank",
        "BankShortCode": "KB",
        "Type": "Non-scheduled banks",
        "Founded": "Dhaka, Bangladesh",
        "Headquarters": "Dhaka, Bangladesh",
        "Website": "Karmasangsthan Bank"
    },
    {
        "BankName": "Meghna Bank Ltd.",
        "BankShortCode": "MBL",
        "Type": "Private Commercial Banks",
        "Founded": "21 April 2013",
        "Headquarters": "Dhaka, Bangladesh",
        "Website": "http://www.meghnabank.com.bd"
    },
    {
        "BankName": "Mercantile Bank Ltd.",
        "BankShortCode": "MBL",
        "Type": "Private Commercial Banks",
        "Founded": "1999",
        "Headquarters": "Dhaka, Bangladesh",
        "Website": "www.mblbd.com"
    },
    {
        "BankName": "Midland Bank Ltd.",
        "BankShortCode": "MBL",
        "Founded": "June 20, 2013",
        "Headquarters": "Gulshan Avenue, Gulshan-2, Dhaka",
        "Type": "Private Commercial Banks",
        "Website": "https://www.midlandbankbd.net/"
    },
    {
        "BankName": "Modhumoti Bank Ltd.",
        "BankShortCode": "MBL",
        "Type": "Private Commercial Banks",
        "Founded": "1999",
        "Headquarters": "Dhaka, Bangladesh",
        "Website": "https://www.modhumotibankltd.com/"
    },
    {
        "BankName": "Mutual Trust Bank Ltd.",
        "BankShortCode": "MTBL",
        "Type": "Private Commercial Banks",
        "Founded": "",
        "Headquarters": "Dhaka, Bangladesh",
        "Website": "mutualtrustbank.com"
    },
    {
        "BankName": "NCC Bank Ltd.",
        "BankShortCode": "NCCBL",
        "Type": "Private Commercial Banks",
        "Founded": "1985",
        "Headquarters": "Dhaka, Bangladesh",
        "Website": ""
    },
    {
        "BankName": "NRB Bank Ltd.",
        "BankShortCode": "NBL",
        "Type": "Private Commercial Banks",
        "Founded": "2013",
        "Founder": "Iqbal Ahmed (OBE)",
        "Headquarters": "Dhaka, Bangladesh",
        "Website": "www.nrbbankbd.com"
    },
    {
        "BankName": "NRB Commercial Bank Ltd.",
        "BankShortCode": "NCBL",
        "Type": "Private Commercial Banks",
        "Founded": "02 April 2013",
        "Website": "https://www.nrbcommercialbank.com/"
    },
    {
        "BankName": "National Bank Ltd.",
        "BankShortCode": "NBL",
        "Type": "Private Commercial Banks",
        "Headquarters": "Dhaka, Bangladesh",
        "Website": "www.nblbd.com"
    },
    {
        "BankName": "National Bank of Pakistan",
        "BankShortCode": "NBOP",
        "Type": "Foreign Commercial Banks",
        "Founded": "1949",
        "Headquarters": "Karachi Pakistan",
        "Owner": "State Bank of Pakistan (75.20%)",
        "Website": "www.nbp.com.pk"
    },
    {
        "BankName": "One Bank Ltd.",
        "BankShortCode": "OBL",
        "Type": "Private Commercial Banks",
        "Founded": "",
        "Headquarters": "Dhaka, Bangladesh",
        "Website": ""
    },
    {
        "BankName": "Padma Bank Ltd.",
        "BankShortCode": "PBL",
        "Type": "Private Commercial Banks",
        "Founded": "2013",
        "Headquarters": "Gulshan-1, Dhaka, Bangladesh",
        "Website": "www.padmabankbd.com"
    },
    {
        "BankName": "Palli Sanchay Bank",
        "BankShortCode": "PSB",
        "Type": "Non-scheduled banks",
        "Founded": "Dhaka, Bangladesh",
        "Headquarters": "Dhaka, Bangladesh",
        "Website": "www.pallisanchaybank.gov.bd"
    },
    {
        "BankName": "Premier Bank Ltd.",
        "BankShortCode": "PBL",
        "Type": "Private Commercial Banks",
        "Founded": "1999",
        "Headquarters": "42 Kemal Ataturk Avenue, Banani, Dhaka, Bangladesh",
        "Website": "www.premierbankltd.com"
    },
    {
        "BankName": "Prime Bank Ltd.",
        "BankShortCode": "PBL",
        "Type": "Private Commercial Banks",
        "Founded": "1995",
        "Headquarters": "Dhaka, Bangladesh",
        "Website": "primebank.com.bd"
    },
    {
        "BankName": "Pubali Bank Ltd.",
        "BankShortCode": "PBL",
        "Type": "Private Commercial Banks",
        "Founded": "1959",
        "Headquarters": "26 Dilkusha Commercial Area Dhaka, Bangladesh",
        "Website": "http://www.pubalibangla.com/"
    },
    {
        "BankName": "Rajshahi Krishi Unnayan Bank",
        "BankShortCode": "RKUB",
        "Type": "Specialized Banks",
        "Founded": "",
        "Website": "http://www.rakub.org.bd/"
    },
    {
        "BankName": "Rupali Bank",
        "BankShortCode": "RBL",
        "Type": "State Owned Commercial Banks",
        "Founded": "1972",
        "Headquarters": "Dhaka, Bangladesh",
        "Website": "rupalibank.org"
    },
    {
        "BankName": "SBAC Bank Ltd.",
        "BankShortCode": "SBAC",
        "Type": "Private Commercial Banks",
        "Founded": "2013",
        "Headquarters": "Dhaka, Bangladesh",
        "Website": ""
    },
    {
        "BankName": "Shahjalal Islami Bank Ltd.",
        "BankShortCode": "SIBL",
        "Type": "Private Commercial Banks",
        "Founded": "Dhaka, Bangladesh",
        "Headquarters": "Dhaka, Bangladesh",
        "Website": "sjiblbd.com"
    },
    {
        "BankName": "Shimanto Bank Ltd.",
        "BankShortCode": "SBL",
        "Type": "Private Commercial Banks",
        "Founded": "Dhaka, Bangladesh",
        "Headquarters": "Dhaka, Bangladesh",
        "Website": "http://www.shimantobank.com/"
    },
    {
        "BankName": "Social Islami Bank Ltd.",
        "BankShortCode": "SIBL",
        "Type": "Private Commercial Banks",
        "Formerly": "Social Investment Bank Limited",
        "Founded": "Dhaka, Bangladesh",
        "Headquarters": "90/1, City Center, Motijheel, Dhaka-1000, Bangladesh",
        "Website": "siblbd.com"
    },
    {
        "BankName": "Sonali Bank",
        "BankShortCode": "SBL",
        "Type": "State Owned Commercial Banks",
        "Founded": "1972",
        "Headquarters": "Motijheel, Dhaka, Bangladesh",
        "Website": "http://sonalibank.com.bd"
    },
    {
        "BankName": "Southeast Bank Ltd.",
        "BankShortCode": "SBL",
        "Type": "Private Commercial Banks",
        "Founded": "1995",
        "Headquarters": "Dhaka, Bangladesh",
        "Website": "www.southeastbank.com.bd"
    },
    {
        "BankName": "Standard Bank Ltd.",
        "BankShortCode": "SBL",
        "Type": "Private Commercial Banks",
        "Founded": "Dhaka, Bangladesh",
        "Headquarters": "Dhaka, Bangladesh",
        "Website": "Standard Bank Limited"
    },
    {
        "BankName": "Standard Chartered Bank",
        "BankShortCode": "SCB",
        "Type": "Foreign Commercial Banks",
        "Founded": "29 December 1853",
        "Founder": "James Wilson",
        "Headquarters": "London, England, UK",
        "Website": "www.sc.com"
    },
    {
        "BankName": "State Bank of India",
        "BankShortCode": "SBOI",
        "Type": "Foreign Commercial Banks",
        "Founded": "2 June 1806",
        "Headquarters": "State Bank Bhawan, M.C. Road, Nariman Point, Mumbai, Maharashtra, India",
        "Website": "bank.sbi"
    },
    {
        "BankName": "The City Bank Ltd.",
        "BankShortCode": "TCBL",
        "Type": "Private Commercial Banks",
        "Founded": "28 March 1983",
        "Founder": "Mr. Monowar Ali, Mr. Ibrahim Mia (Late), Mr. Abdul Hadi (Late), Mr. M.A. Hashem (Late), Mr. Anwar Hossain, Mr. Abdul Barik Choudhury (Late), Mr. Deen Mohammad, Mr. A.B.M. Feroz, Mr. Md. Ali Hossain, Mr. Azizul Haque Chowdhury, Mr. N.A. Chowdhury (Late)",
        "Headquarters": "136 Gulshan Avenue, Circle 2, Gulshan, Dhaka, Bangladesh",
        "Website": "thecitybank.com"
    },
    {
        "BankName": "Trust Bank Ltd.",
        "BankShortCode": "TBL",
        "Type": "Private Commercial Banks",
        "Founded": "1999",
        "Headquarters": "Shadhinota Tower, Bir Srestha Shahid Jahangir Gate, Dhaka Cantonment, Dhaka, Bangladesh",
        "Website": "www.tblbd.com"
    },
    {
        "BankName": "Union Bank Ltd.",
        "BankShortCode": "UBL",
        "Type": "Private Commercial Banks",
        "Website": "https://www.unionbank.com.bd/"
    },
    {
        "BankName": "United Commercial Bank Ltd.",
        "BankShortCode": "UCBL",
        "Type": "Private Commercial Banks",
        "Founded": "",
        "Founder": "Akhtaruzzaman Chowdhury Babu",
        "Headquarters": "Dhaka, Bangladesh",
        "Website": "www.ucb.com.bd"
    },
    {
        "BankName": "Uttara Bank Ltd.",
        "BankShortCode": "UBL",
        "Type": "Private Commercial Banks",
        "Founded": "Dhaka, Bangladesh (1965)",
        "Headquarters": "Dhaka, Bangladesh",
        "Website": "www.uttarabank-bd.com"
    },
    {
        "BankName": "Woori Bank Ltd.",
        "BankShortCode": "WBL",
        "Type": "Foreign Commercial Banks",
        "Founded": "30 January 1899",
        "Headquarters": "Hoehyeon-dong, Jung-gu, Seoul, South Korea",
        "Website": "www.wooribank.com"
    }
]

export interface IResponseData {
    data: IBank[]
}